/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import connect from 'react-redux/es/connect/connect';
import { t } from 'utils/translates';

import { selectRating } from 'mt-react-common/modules/users/common/reducers/states/authAccount';

import { sendRequest as sendTaskToggleChosenMarkFormRequest } from 'mt-react-common/modules/tasks/common/reducers/taskToggleChosenMarkForm';
import { sendRequest as sendTaskToggleHideMarkFormRequest } from 'mt-react-common/modules/tasks/common/reducers/taskToggleHideMarkForm';

import TasksToExecutorsListItemHeader from './TasksToExecutorsListItemHeader';
import TasksToExecutorsListItemBody from './TasksToExecutorsListItemBody';
import ManageBlock from './ManageBlock';

// eslint-disable-next-line react/prefer-stateless-function
class TasksToExecutorsListItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      markHideButtonId: `markHideButton-${this.props.task.id}`,
      markChosenButton: `markChosenButton-${this.props.task.id}`
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.task.has_mark_hide !== this.props.task.has_mark_hide) {
      // eslint-disable-next-line no-undef
      $(`#${this.state.markHideButtonId}`)
        .tooltip('fixTitle')
        .tooltip('hide');
    }
    if (prevProps.task.has_mark_chosen !== this.props.task.has_mark_chosen) {
      // eslint-disable-next-line no-undef
      $(`#${this.state.markChosenButton}`)
        .tooltip('fixTitle')
        .tooltip('hide');
    }
  }

  render() {
    const styles = {};
    if (this.props.task.reasons_locked_for_execution.length > 0) {
      styles.opacity = 0.5;
    }
    const isShowActionButtonsForTask =
      !this.props.isTaskFromAuthUser &&
      !this.props.task.reasons_locked_for_execution.length > 0;
    return (
      <React.Fragment>
        <article
          className={`${
            this.props.task.is_highlighted
              ? 'panel panel-warning task task_detailed'
              : 'panel task task_detailed panel-default'
          }`}
          style={styles}
        >
          <TasksToExecutorsListItemHeader
            task={this.props.task}
            isTaskFromAuthUser={this.props.isTaskFromAuthUser}
          />
          <div className="panel-body">
            <TasksToExecutorsListItemBody
              task={this.props.task}
              isTaskFromAuthUser={this.props.isTaskFromAuthUser}
            />
          </div>
          <div className="panel-footer panel-inner-border-top">
            <div className="btn-toolbar">
              <div className="btn-group btn-group-sm pull-left">
                <div className="btn btn-default btn-view">
                  <span
                    className="text-success"
                    data-container="body"
                    data-toggle="tooltip"
                    title={t('Выполнено')}
                  >
                    {this.props.task.task_stat.exec_status_finished_count}
                  </span>{' '}
                  <span className="text-muted">•</span>{' '}
                  <span
                    data-container="body"
                    data-toggle="tooltip"
                    title={t('Ожидает проверки')}
                  >
                    {this.props.task.task_stat.exec_status_at_checkout_count}
                  </span>{' '}
                  <span className="text-muted">•</span>{' '}
                  <span
                    className="text-danger"
                    data-container="body"
                    data-toggle="tooltip"
                    title={t('Обращений в арбитраж исполнителями')}
                  >
                    {this.props.task.task_stat.exec_status_dispute_count}
                  </span>
                </div>
                <div className="btn btn-default btn-view">
                  <span
                    data-container="body"
                    data-toggle="tooltip"
                    title={t('Положительные отзывы')}
                  >
                    <i className="text-primary fa fa-thumbs-o-up" />{' '}
                    <span className="text-muted">
                      {this.props.task.task_stat.comment_likes_count}
                    </span>
                  </span>{' '}
                  <span
                    data-container="body"
                    data-toggle="tooltip"
                    title={t('Отрицательные отзывы')}
                  >
                    <i className="text-primary fa fa-thumbs-o-down" />{' '}
                    <span className="text-muted">
                      {this.props.task.task_stat.comment_dislikes_count}
                    </span>
                  </span>
                </div>
                {this.props.task.adult_content === 1 ? (
                  <div className="btn btn-default btn-view">
                    <span
                      className="text-danger"
                      data-container="body"
                      data-toggle="tooltip"
                      title={t('Контент для лиц достигших совершеннолетия')}
                    >
                      <strong>18+</strong>
                    </span>
                  </div>
                ) : null}
                {this.props.task.software_install === 1 ? (
                  <div className="btn btn-default btn-view">
                    <span
                      className="text-danger"
                      data-container="body"
                      data-toggle="tooltip"
                      title={t('Задание требует установку ПО')}
                    >
                      <strong>{t('ПО')}</strong>
                    </span>
                  </div>
                ) : null}
              </div>
              {this.props.task.reasons_locked_for_execution.length > 0 ? (
                <button
                  className="btn btn-default btn-sm"
                  type="button"
                  data-container="body"
                  data-toggle="tooltip"
                  title={this.props.task.reasons_locked_for_execution.join(
                    ', '
                  )}
                >
                  {t('Выполнить')}
                </button>
              ) : null}
              {isShowActionButtonsForTask ? (
                <Link
                  to={`/earn-money/task-view/${this.props.task.id}/desc`}
                  className="btn btn-success btn-sm"
                  type="button"
                >
                  {t('Выполнить')}
                </Link>
              ) : null}
              {isShowActionButtonsForTask ? (
                <button
                  id={this.state.markHideButtonId}
                  className="btn btn-muted btn-sm"
                  data-toggle="tooltip"
                  type="button"
                  title={
                    this.props.task.has_mark_hide ? t(`Показать`) : t(`Скрыть`)
                  }
                  onClick={() => this.props.taskToggleHideMark()}
                >
                  <i
                    className={`fa ${
                      this.props.task.has_mark_hide ? 'fa-eye-slash' : 'fa-eye'
                    }`}
                  />
                </button>
              ) : null}
              {isShowActionButtonsForTask ? (
                <button
                  id={this.state.markChosenButton}
                  className="btn btn-muted btn-sm"
                  data-toggle="tooltip"
                  type="button"
                  title={
                    this.props.task.has_mark_chosen
                      ? t(`Удалить из избранных`)
                      : t(`В избранное`)
                  }
                  onClick={() => this.props.taskToggleChosenMark()}
                >
                  <i
                    className={`fa ${
                      this.props.task.has_mark_chosen
                        ? 'fa-bookmark'
                        : 'fa-bookmark-o'
                    }`}
                  />
                </button>
              ) : null}
              <ManageBlock
                taskModel={this.props.task}
                onRefreshParentContent={this.props.onRefreshParentContent}
              />
            </div>
          </div>
        </article>
      </React.Fragment>
    );
  }
}

TasksToExecutorsListItem.defaultProps = {
  onRefreshParentContent: () => {}
};

TasksToExecutorsListItem.propTypes = {
  // IN
  isTaskFromAuthUser: PropTypes.bool.isRequired,
  task: PropTypes.shape({
    id: PropTypes.number.isRequired,
    adult_content: PropTypes.number.isRequired,
    software_install: PropTypes.number.isRequired,
    pExecutorMinRating: PropTypes.number.isRequired,
    reasons_locked_for_execution: PropTypes.arrayOf(PropTypes.string),
    has_mark_hide: PropTypes.bool.isRequired,
    has_mark_chosen: PropTypes.bool.isRequired,
    is_pinned: PropTypes.bool.isRequired,
    is_highlighted: PropTypes.bool.isRequired,
    taskCommentsStat: PropTypes.shape({
      likes: PropTypes.number.isRequired,
      dislikes: PropTypes.number.isRequired
    }).isRequired,
    task_stat: PropTypes.shape({
      exec_status_at_checkout_count: PropTypes.number,
      exec_status_finished_count: PropTypes.number,
      exec_status_dispute_count: PropTypes.number,
      comment_likes_count: PropTypes.number,
      comment_dislikes_count: PropTypes.number
    }).isRequired,
    upListMarkNow: PropTypes.shape({
      andTime: PropTypes.string
    })
  }).isRequired,
  authUserRating: PropTypes.shape({
    rating: PropTypes.string.isRequired,
    ratingStatusTitle: PropTypes.string.isRequired,
    ratingStatusPoints: PropTypes.number.isRequired,
    ratingStatusPointsTo: PropTypes.number.isRequired
  }).isRequired,
  // CONNECT
  taskToggleChosenMark: PropTypes.func.isRequired,
  taskToggleHideMark: PropTypes.func.isRequired,
  onRefreshParentContent: PropTypes.func
};

// eslint-disable-next-line no-unused-vars
const mapStateToProps = (state, props) => ({
  authUserRating: selectRating(state)
});

const mapDispatchToProps = (dispatch, props) => ({
  taskToggleChosenMark: () =>
    dispatch(
      sendTaskToggleChosenMarkFormRequest(
        'tasksModule.forms.taskToggleChosenMarkForm',
        props.task.id
      )
    ),
  taskToggleHideMark: () =>
    dispatch(
      sendTaskToggleHideMarkFormRequest(
        'tasksModule.forms.taskToggleHideMarkForm',
        props.task.id
      )
    )
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TasksToExecutorsListItem)
);



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksToExecutorsList/TasksToExecutorsListItem/index.js